export default __webpack_public_path__ + "static/1.pcf-logo_1-00711578548bb5bc142e6544cb23d760.png";